<div
    class="agpr-deliveryRangeScheduler"
    role="radiogroup"
    [attr.aria-label]="'Briefings.sidebar.headingSchedulingOptions' | localize"
    [attr.aria-describedby]="ariaDescribedBy"
>
    <ng-container *ngIf="canSelectOngoing">
        <div class="agpr-deliveryRangeScheduler-radio">
            <agpr-radio
                [id]="id + '-ongoingRadioButton'"
                name="delivery-range-{{id}}"
                [disabled]="disabled"
                label="DeliveryRangeScheduler.ongoing"
                hiddenLabel="DeliveryRangeScheduler.ongoing"
                [value]="rangeTypeOngoing"
                [(ngModel)]="selectedRangeType"
                (ngModelChange)="ongoingSelected()"
            ></agpr-radio>
            <span
                *ngIf="showOngoingTooltip"
                class="fa-regular fa-circle-info agpr-deliveryRangeScheduler-radio--toolTipIcon"
                agprTooltip="DeliveryRangeScheduler.ongoingTooltip"
                tooltipPosition="top"
                role="img"
            ></span>
        </div>
        <div class="agpr-deliveryRangeScheduler-radio">
            <agpr-radio
                [id]="id + '-timePeriodRadioButton'"
                name="delivery-range-{{id}}"
                [disabled]="disabled"
                [label]="timePeriodLabel"
                [hiddenLabel]="timePeriodLabel"
                [value]="rangeTypeRange"
                [(ngModel)]="selectedRangeType"
                (ngModelChange)="rangeSelected()"
            ></agpr-radio>
        </div>
    </ng-container>
    <div
        *ngIf="!canSelectOngoing || selectedRangeType === rangeTypeRange"
        class="agpr-deliveryRangeScheduler-dateRange"
        role="group"
        [attr.aria-labelledby]="id + '-timePeriodRadioButton' + '-radioLabel'"
    >
        <div class="agpr-deliveryRangeScheduler-start">
            <label [id]="id + '_startLabel'" >
                {{ startLabel | localize }}
                <span class="u-srOnly">{{ 'dateFormat' | localize }}</span>
            </label>
            <div class="ui-fluid agpr-deliveryRangeScheduler-dateTime" role="group" [attr.aria-labelledby]="id + '-startLabel'">
                <div class="agpr-inputOverlay agpr-deliveryRangeScheduler-date">
                    <agpr-date-picker
                        #startCalendar
                        [readonlyInput]="disabled"
                        [minDate]="minStartDate"
                        [maxDate]="realMaxStartDate"
                        [ariaLabelledBy]="id + '_startLabel'"
                        [(ngModel)]="startDate"
                        (ngModelChange)="startDateChanged()"
                    ></agpr-date-picker>
                </div>
                <agpr-time-picker
                    class="agpr-deliveryRangeScheduler-time"
                    [id]="id + '-startDate'"
                    hourDescribedBy="start-date-errors-{{id}}"
                    minuteDescribedBy="start-date-errors-{{id}}"
                    [disabled]="disabled"
                    [showTimeZoneSelector]="false"
                    [ngModel]="startTime"
                    (changeHour)="startTimeChanged()"
                    (changeMinute)="startTimeChanged()"
                    (changeMeridian)="startTimeChanged()"
                ></agpr-time-picker>
            </div>
        </div>
        <div class="agpr-deliveryRangeScheduler-end">
            <label [id]="id + '_endLabel'">
                {{ endLabel | localize }}
                <span class="u-srOnly">{{ 'dateFormat' | localize }}</span>
            </label>
            <div class="ui-fluid agpr-deliveryRangeScheduler-dateTime" role="group" [attr.aria-labelledby]="id + '-endLabel'">
                <div class="agpr-inputOverlay agpr-deliveryRangeScheduler-date">
                    <agpr-date-picker
                        #endCalendar
                        [readonlyInput]="disabled"
                        [minDate]="realMinEndDate"
                        [maxDate]="maxEndDate"
                        [ariaLabelledBy]="id + '_endLabel'"
                        [(ngModel)]="endDate"
                        (ngModelChange)="endDateChanged()"
                    ></agpr-date-picker>
                </div>
                <agpr-time-picker
                    class="agpr-deliveryRangeScheduler-time"
                    [id]="id + '-endDate'"
                    hourDescribedBy="end-date-errors-{{id}}"
                    minuteDescribedBy="end-date-errors-{{id}}"
                    [disabled]="disabled"
                    [showTimeZoneSelector]="false"
                    [ngModel]="endTime"
                    (changeHour)="endTimeChanged()"
                    (changeMinute)="endTimeChanged()"
                    (changeMeridian)="endTimeChanged()"
                ></agpr-time-picker>
            </div>
        </div>
        <div class="agpr-deliveryRangeScheduler-timezone">
            <agpr-timezone-picker
                class='agpr-timePicker-timeZoneDropdown'
                [id]="id"
                [(ngModel)]="timezone"
                [disabled]="disabled"
                (ngModelChange)="timezoneChanged()"
                [defaultToUserPreference]= "false"
                label="timezone"
            ></agpr-timezone-picker>
        </div>
    </div>
</div>
